import React from "react";
import styled from "styled-components";
import {
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
  Partition,
} from "../index.styled";
import { ReactComponent as PatientExperienceIcon } from "../../../Assets/Icons/PatientExperience.svg";
import CustomInput from "../../Input";
import CustomSlider from "../../CustomSlider";
import { viewSizeCalculator } from "../../../utils";

const PatientExperience = ({ data, reference, handleInputChange }) => {
  const fields = data.fields;
  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <PatientExperienceIcon />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <RowContainer width={"25%"}>
          <CustomInput
            type={"text"}
            dropdown={fields[0].type}
            placeholder={fields[0].placeholder}
            onChange={handleInputChange}
            height={2.2}
          />
        </RowContainer>
        <RowContainer wrap={true} alignItems={"flex-start"}>
          <CustomSlider
            title="Communication with Nurses/Doctors"
            isRatingSlider={true}
            ratingPoints={3}
            showLabeledRating={true}
          />
          <CustomSlider
            title="Appointment Wait Time"
            isRatingSlider={true}
            ratingPoints={3}
            showLabeledRating={true}
          />
          <CustomSlider
            title="Cleanliness and Quietness Rating"
            ratingPoints={5}
            isRatingSlider={true}
          />
        </RowContainer>
        <Partition />
        <RowContainer flexDirection={"column"} alignItems={"flex-start"}>
          <CheckboxContainer>
            <input
              style={{
                cursor: "pointer",
                accentColor: "#F96250",
                width: viewSizeCalculator(1.063),
                height: viewSizeCalculator(1.063),
              }}
              type="checkbox"
              id={fields[5].label}
            />
            <CheckboxLabel htmlFor={fields[5].label}>
              {fields[5].label}
            </CheckboxLabel>
          </CheckboxContainer>
          <CheckboxContainer>
            <input
              style={{
                cursor: "pointer",
                accentColor: "#F96250",
                width: viewSizeCalculator(1.063),
                height: viewSizeCalculator(1.063),
              }}
              type="checkbox"
              id={fields[6].label}
            />
            <CheckboxLabel htmlFor={fields[6].label}>
              {fields[6].label}
            </CheckboxLabel>
          </CheckboxContainer>
          <CheckboxContainer>
            <input
              style={{
                cursor: "pointer",
                accentColor: "#F96250",
                width: viewSizeCalculator(1.063),
                height: viewSizeCalculator(1.063),
              }}
              type="checkbox"
              id={fields[7].label}
            />
            <CheckboxLabel htmlFor={fields[7].label}>
              {fields[7].label}
            </CheckboxLabel>
          </CheckboxContainer>
        </RowContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default PatientExperience;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || "center"};
  justify-content: space-between;
  flex-direction: ${({ flexDirection }) => flexDirection || "row"};
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: ${viewSizeCalculator(1.2)};
  width: ${({ width }) => width || "70%"};
`;
